import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("cb_lang") || "en";
    } catch (_) {
      return "en";
    }
  });

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    try {
      localStorage.setItem("cb_lang", lang);
    } catch (_) {
      /* ignore storage errors */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang],
      isRTL: lang === "ar",
      toggle: () => setLang((p) => (p === "en" ? "ar" : "en")),
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}

export const WHATSAPP_NUMBER = ""; // Leave blank - update once client provides the number
export const HAS_WHATSAPP = Boolean(WHATSAPP_NUMBER);
export const WHATSAPP_LINK = (text) =>
  WHATSAPP_NUMBER
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "Hi Capital Bay, I'd like to learn more about your Financial Management Review.")}`
    : "#";
